import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

type PageStatusSectionTitleProps = {
  title: string;
  helper?: string;
};

export const PageStatusSectionTitle: FC<PageStatusSectionTitleProps> = ({ title, helper }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant='h6'>{title}</Typography>

    {helper && (
      <Typography variant='body2' color='text.secondary'>
        {helper}
      </Typography>
    )}
  </Box>
);
